import { useCallback } from "react";
import { fetchDataAlleGebruikersPage } from "../../apiCalls/usersApi";
import useInfiniteList from "../../hooks/useInfiniteList";

export const GEBRUIKERS_PAGE_SIZE = 50;

const getGebruikerKey = (item) =>
  item?.id || item?.email || item?.username || item?.phone;

const useInfiniteGebruikers = ({ desiredColumns, role, search, type }) => {
  const fetchPage = useCallback(
    (page, pageSize) =>
      fetchDataAlleGebruikersPage(
        page,
        pageSize,
        desiredColumns,
        role,
        type,
        search
      ),
    [desiredColumns, role, search, type]
  );

  return useInfiniteList({
    fetchPage,
    getItemKey: getGebruikerKey,
    pageSize: GEBRUIKERS_PAGE_SIZE,
    resetKey: `${role ?? 999}:${type}:${search}`,
  });
};

export default useInfiniteGebruikers;
